export const FINANCE_REPORT_HUB_PATH = "reports/finance";

export const FINANCE_REPORT_GROUPS = [
  {
    id: "statements",
    title: "Financial statements",
    description: "Core GL-derived statements for period close and audit.",
    reports: [
      {
        path: "reports/finance/trial-balance",
        title: "Trial Balance",
        description: "Debit and credit balances by account with balance check.",
        icon: "table",
      },
      {
        path: "reports/finance/balance-sheet",
        title: "Balance Sheet",
        description: "Assets, liabilities, and equity as of period end.",
        icon: "profit",
      },
      {
        path: "reports/finance/income-statement",
        title: "Income Statement",
        description: "Revenue, expenses, and net income for the period.",
        icon: "charts",
      },
      {
        path: "reports/finance/cash-flow",
        title: "Cash Flow",
        description: "Operating, investing, and financing cash movements.",
        icon: "collection",
      },
    ],
  },
  {
    id: "analysis",
    title: "Analysis & detail",
    description: "Drill-down registers and variance analysis.",
    reports: [
      {
        path: "reports/finance/general-ledger",
        title: "General Ledger",
        description: "Posted journal lines by account and date range.",
        icon: "file",
      },
      {
        path: "reports/finance/budget-vs-actual",
        title: "Budget vs Actual",
        description: "Budget lines compared to posted GL activity.",
        icon: "rate",
      },
      {
        path: "reports/finance/vat-summary",
        title: "VAT Summary",
        description: "Tax base and VAT by code for the selected period.",
        icon: "orders",
      },
    ],
  },
  {
    id: "treasury",
    title: "Treasury & capital",
    description: "Liquidity and funding position (lending operations).",
    reports: [
      {
        path: "reports/working-capital",
        title: "Working Capital",
        description: "Branch float, movements, and utilization.",
        icon: "wallet",
      },
      {
        path: "reports/funding-accounts",
        title: "Funding Accounts",
        description: "Partner funding balances and allocations.",
        icon: "bank_transfer",
      },
      {
        path: "reports/revenue",
        title: "Revenue & Profitability",
        description: "Lending revenue, fees, and margin trends.",
        icon: "income",
      },
    ],
  },
];

export const ALL_FINANCE_REPORTS = FINANCE_REPORT_GROUPS.flatMap((g) => g.reports);
